import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, of, map, catchError } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserState } from '../store/User/UserReducer';
import { initCsrfTokenSelector } from '../store/User/UserSelector';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  constructor(private readonly userStore: Store<UserState>) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let csrfToken: string | null = null;
    this.userStore
      .select(initCsrfTokenSelector)
      .pipe(
        map((token) => (csrfToken = token)),
        catchError((error) => {
          console.error('Error getting CSRF token from store:', error);
          return of(null);
        }),
      )
      .subscribe()
      .unsubscribe();

    if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(req.method) && csrfToken) {
      const cloned = req.clone({
        setHeaders: { 'X-XSRF-TOKEN': csrfToken },
      });
      return next.handle(cloned);
    }

    return next.handle(req);
  }
}
